
import { Organization } from '@/models/Organization';
import {Component, Prop, Vue} from 'vue-property-decorator';
import { RideitInvitationMessageDirective } from '@/models/Rideit/RideitInvitation';
import RideitInvitationFormData from '@/models/Rideit/RideitInvitationFormData';



@Component({
  components: {
  }
})
export default class RideitInvitationForm extends Vue {
  formRef = 'invitationForm' as const;

  organization: Organization = this.getOrganization();

  rules = {
    required: (val: any) => !!val || this.$t('validation.rules.required', 'Required'),
    mustContainLink: (val: string) => {
      if (val.includes(RideitInvitationMessageDirective)) {
        return true;
      }
      return this.$t('rideIt.invitations_message_must_contain_link', { link: RideitInvitationMessageDirective });
    },
  }

  @Prop({}) private value: RideitInvitationFormData;

  get formElement() {
    return this.$refs[this.formRef] as Vue & { validate: () => boolean, resetValidation: () => void, reset: () => void };
  }

  get invitationForm() {
    return this.value;
  }

  set invitationForm(newValue: RideitInvitationFormData) {
    this.updateValue(newValue);
  }

  get selectedPassengerCount() {
    return this.invitationForm?.selected?.length ?? 0;
  }

  get possibleInvitationsCount() {
    return this.invitationForm.createInvitationsRequest?.invitations?.length ?? 0;
  }

  get disableSendButton() {
    const noSelectedPassengers = this.selectedPassengerCount === 0;
    const noPossibleInvitations = this.possibleInvitationsCount === 0;
    return noSelectedPassengers || noPossibleInvitations;
  }

  sendInvitations() {
    if (!this.formElement.validate() || this.possibleInvitationsCount === 0) {
      return;
    }
    this.$emit('save');
  }
  
  getOrganization() {
    const organizationId = this.$route.params.organizationId;
    return this.$store.state.organization.organizations.find((o: Organization) => o.id === organizationId);
  }

  updateValue(newValue: RideitInvitationFormData) {
    this.$emit('input', newValue);
  }
}
